export const formatStatus = (status: string): string =>
  status.split('_').join(' ')
